const messages: Record<string, string> = {
	'landing.aboutPolicyCheck': 'What the PolicyCheck is?',
	'tutorialModal.headline.first.policyCheck': 'What is behind PolicyCheck?',
	'tutorialModal.paragraph.first.policyCheck':
		'PolicyCheck is a quick vehicle inspection. The inspection process consists of a few simple steps in which you are supposed to take 10 photos.',

	'button.start': 'Next',

	'feedback.headline.policyCheck': 'Thank you for using PolicyCheck!',
	'feedback.description':
		'We hope that you were satisfied with our service and look forward to your feedback.',
	'feedback.rating.policyCheck': 'How do you rate the car inspection with PolicyCheck?',
	'feedback.yourOpinion': 'Your opinion',
	'feedback.button.send': 'Send the opinion',

	'thanks.headline.first': 'Thank you',
	'waitForAudit.description.damageFound':
		'The next step is up to us. We will inform you about the result of the inspection by SMS or e-mail.',

	'thanks.paragraph.first': 'Thank you for using application!',

	'tutorialModal.paragraph.second': ' ',

	'landing.additional-informations-section.title':
		'Before starting the inspection of your vehicle, check that:',
	'landing.additional-informations-section.text':
		'<ul>' +
		'<li>you have the keys and the registration certificate at hand</li>' +
		'<li>you are in a place with good light and mobile network</li>' +
		'</ul>',

	'imageRecognitionMismatchModal.headline':
		'Are you sure you added the right photo?<br><br>If incorrect photos are added, they may not be accepted at a later stage.',

	'vehicleImages.description':
		'Take a photo so that each element is visible in each section. Photos cannot be cropped. Try to fit the whole car in the frame.',
	'fourAdditionalPictures.overallDashboard.description':
		"Photograph your vehicle's dashboard completely.<br>We suggest taking a photo from the back seat.",

	'landing.termsAndConditionsLinkDescription': 'To start, please click next.',

	'vehicleImages.overviewPhotos.subtitle': ' ',

	'invalidFile.size.title': 'Incorrect image size',
	'invalidFile.size.description': 'The image size is bigger than the maximum required',
	'invalidFile.extension.title': 'File type is not supported',
	'invalidFile.extension.description':
		'The specified file type is not supported. Supported file types: .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
